import { render } from "./ExportarConsultaPrescripcionesView.vue?vue&type=template&id=ffaefade&scoped=true"
import script from "./ExportarConsultaPrescripcionesView.vue?vue&type=script&lang=js"
export * from "./ExportarConsultaPrescripcionesView.vue?vue&type=script&lang=js"

import "./ExportarConsultaPrescripcionesView.vue?vue&type=style&index=0&id=ffaefade&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffaefade"]])

export default __exports__